import request from '@/utils/signup'

// 申请试用
export function userSign(data) {
  return request({
    url: '/trialUse/v1/userSign.do',
    data,
  })
}
// 获取验证码
export function sendVerificationCode(data) {
  return request({
    url: '/trialUse/v1/sendVerificationCode.do',
    data,
  })
}
// 查询体验资格
export function trialQuery(data) {
  return request({
    url: '/trialUse/v1/trialQuery.do',
    data,
  })
}
